module.exports = __webpack_public_path__ + "img/11.4349c304.webp";